var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-ins-progress-bar'),_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrolltop text-center",attrs:{"id":"scroll-to-top"}},[_c('i',{staticClass:"fas fa-chevron-up",staticStyle:{"font-size":"20px"}})])
}]

export { render, staticRenderFns }